import { Group, Stack } from '@mantine/core';
import React, { ChangeEvent } from 'react';
import { OpenComponent } from '../../enums/misc.enum';
import { Roles } from '../../enums/roles-enum';
import { truncateString } from '../../helpers/common.helpers';
import useAuth from '../../hooks/useAuth';
import { BasicMerchantBranch } from '../../type/entity.types';
import StatusText from '../admin-table/components/status-text.component';
import XSafeTextInfo from '../x-components/x-safe-text-info.component';
import XSkeletonLoadingTableBody from '../x-components/x-skeletons/x-skeleton-loading-table.component';
import XThead from '../x-components/x-table-header.component';
import XTable from '../x-components/x-table/x-table.component';

interface Props {
  branchesData: BasicMerchantBranch[] | undefined;
  setSelectedEntity: React.Dispatch<React.SetStateAction<number | undefined>>;
  setComponentManager: React.Dispatch<React.SetStateAction<OpenComponent>>;
  isChecked: number[];
  setIsChecked: React.Dispatch<React.SetStateAction<number[]>>;
  checkedAll: boolean;
  setCheckedAll: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading: boolean;
}

function BranchesTable(props: Props) {
  const {
    branchesData,
    setSelectedEntity,
    setComponentManager,
    isChecked,
    setIsChecked,
    checkedAll,
    setCheckedAll,
    isLoading,
  } = props;
  const { auth } = useAuth();
  const isViewOnly =
    auth?.role === Roles.SETTLEMENT || auth?.role === Roles.CHECKER;

  const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target;
    if (checked) {
      setIsChecked([...isChecked, Number(id)]);
    } else {
      setIsChecked(isChecked.filter((item) => item !== Number(id)));
    }
  };

  const handleCheckAll = () => {
    if (!branchesData) {
      return;
    }
    let arr = branchesData;
    setCheckedAll(!checkedAll);

    if (checkedAll) {
      setIsChecked([]);
    } else {
      setIsChecked(arr.map((li) => li.branchId));
    }
  };

  return (
    <>
      <XTable>
        <XThead>
          <tr>
            {!isViewOnly && (
              <th style={{ width: 30 }}>
                <input
                  type='checkbox'
                  style={{ cursor: 'pointer' }}
                  onChange={handleCheckAll}
                  checked={checkedAll}
                />
              </th>
            )}
            <th>Branch name</th>
            <th>Primary contact number</th>
            <th>POSs</th>
            <th>Association</th>
            <th>Status</th>
          </tr>
        </XThead>
        {isLoading ? (
          <XSkeletonLoadingTableBody numColumns={6} />
        ) : (
          <tbody>
            {branchesData?.map((branch) => (
              <tr key={branch.branchId}>
                {!isViewOnly && (
                  <td>
                    <input
                      type='checkbox'
                      style={{ cursor: 'pointer' }}
                      id={branch.branchId.toString()}
                      checked={isChecked.includes(branch.branchId)}
                      onChange={handleCheck}
                    />
                  </td>
                )}

                <td
                  onClick={() => {
                    setSelectedEntity(branch.branchId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <XSafeTextInfo data={truncateString(branch.branchName, 20)} />
                </td>
                <td
                  onClick={() => {
                    setSelectedEntity(branch.branchId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <XSafeTextInfo data={branch.contact.phone.primary} />
                </td>
                <td
                  onClick={() => {
                    setSelectedEntity(branch.branchId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <XSafeTextInfo data={branch.posCount} />
                </td>
                <td
                  onClick={() => {
                    setSelectedEntity(branch.branchId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <Stack spacing='xs'>
                    <Group>
                      <XSafeTextInfo data='Reseller:' />
                      <XSafeTextInfo
                        data={branch.parentReseller}
                        weight={600}
                      />
                    </Group>
                    <Group>
                      <XSafeTextInfo data='Merchant:' />
                      <XSafeTextInfo
                        data={branch.parentMerchant}
                        weight={600}
                      />
                    </Group>
                  </Stack>
                </td>
                <td
                  onClick={() => {
                    setSelectedEntity(branch.branchId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <StatusText
                    status={branch.isActive ? 'ENABLED' : 'DISABLED'}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        )}
      </XTable>
    </>
  );
}

export default BranchesTable;
